import { useMemo } from 'react'
import { useGetActivityGroupAnswerById } from './api'

export default function useAnswerGroupById({ activityGroupId, activityGroupAnswerId, cisUserId, enabled }) {
  const [refetch, { data, loading, isError }] = useGetActivityGroupAnswerById({
    activityGroupId,
    activityGroupAnswerId,
    cisUserId,
    enabled,
  })

  const answers = data ?? null

  const memoryArtifact = useMemo(() => {
    if (!answers?.memoryArtifact) return null
    return {
      ...answers?.memoryArtifact,
      createDate: answers?.createDate,
      completeDate: answers?.completeDate,
      authorCisId: answers?.cisUserId,
      answerId: answers?.id,
      grouping: answers?.grouping ?? null,
    }
  }, [answers])

  const mode = answers?.completeDate ? 'review' : 'input'

  return { refetch, answers, memoryArtifact, mode, isLoading: loading, isError }
}
